import {useEffect, useMemo, useRef} from "react";
import {Observer} from "mobx-react";
import {XyiconFeature} from "../../../generated/api/base";
import {ModuleViewV5} from "../abstract/ModuleViewV5";
import {useAppStore} from "../../../StateManager";
import {PortfolioCreatePopupV5} from "./portfolio/PortfolioCreatePopupV5";
import {getActionBarButtonsForFeature} from "./ActionBarUtils";

const OWN_FEATURE = XyiconFeature.Portfolio;

interface IPortfolioViewV5Props {}

export const PortfolioViewV5 = (props: IPortfolioViewV5Props) => {
	const _moduleView = useRef<ModuleViewV5>(null);
	const createButtonRef = useRef<HTMLDivElement>(null);
	const appState = useAppStore((state) => state.appState);
	const {transport} = appState.app;

	useEffect(() => {
		const {actions} = appState;

		const currentPortfolioMaybe = actions.getCurrentPortfolio();

		if (currentPortfolioMaybe) {
			appState.app.navigation.updatePortfolioRefIdInUrl(currentPortfolioMaybe.refId);
			appState.app.transport.services.feature.refreshList(XyiconFeature.PortfolioDocument);
		}
	}, [appState, transport.services.auth, transport.services.localStorage]);

	const activePortfolioMaybe = appState.activePortfolio;

	const spaceArray = appState.lists[XyiconFeature.Space].array;

	useEffect(() => {
		// If Portfolio A is active, but B is the focused, the Spaces list are refreshed to show the focused Portfolio's Spaces
		// If we navigate out from the Portfolio module, the Spaces list should be refreshed again to show the active Portfolio's Spaces
		return () => {
			if (activePortfolioMaybe) {
				const isSpaceListUpdatedForActivePortfolio = spaceArray[0]?.portfolioId === activePortfolioMaybe.id;

				if (!isSpaceListUpdatedForActivePortfolio) {
					appState.app.transport.services.feature.refreshList(XyiconFeature.Space, true, activePortfolioMaybe.id);
				}
			}
		};
	}, [appState.app.transport.services.feature, spaceArray, activePortfolioMaybe]);

	const actionBarButtons = useMemo(() => getActionBarButtonsForFeature(OWN_FEATURE, appState), [appState]);

	return (
		<Observer>
			{() => {
				return (
					<ModuleViewV5
						ref={_moduleView}
						feature={OWN_FEATURE}
						actionBar={actionBarButtons}
						create={(onClose) => (
							<PortfolioCreatePopupV5
								onClose={() => {
									onClose();
								}}
								parentRef={createButtonRef}
							/>
						)}
						createButtonRef={createButtonRef}
					/>
				);
			}}
		</Observer>
	);
};
